import { z } from 'zod/v4';

import { coercedDate } from '../../../utils/coerced-date';
import { smsStatusOptions, smsStatusSchema } from './sms-status.schema';

export const smsInviteStatusSchema = z.object({
  id: z.number(),
  entityId: z.string(),
  statusText: smsStatusSchema,
  statusCode: z
    .number()
    .min(0)
    .max(smsStatusOptions.length - 1),
  errorCode: z.number().optional(),
  messageBody: z.string(),
  toPhoneNumber: z.string(),
  productFamily: z.string(),
  createdTimestamp: coercedDate,
  modifiedTimestamp: coercedDate,
  canResendInvite: z.boolean(),
});

export type SmsInviteStatus = z.infer<typeof smsInviteStatusSchema>;
